export enum ProfileReportReasonType {
  Slander = 'Slander',
  Spam = 'Spam',
  SexualHarassment = 'SexualHarassment',
  ExposurePersonalInformation = 'ExposurePersonalInformation',
  CopyrightInfringement = 'CopyrightInfringement',
  AbuseForRewards = 'AbuseForRewards',
  Other = 'Other',
}

export enum ProfileDetailTabType {
  Content = 'Content',
  Reply = 'Reply',
  FancyShare = 'FancyShare',
  Rolling = 'Rolling',
}

export const ProfileDetailTabTypeString = {
  [ProfileDetailTabType.Content]: '작품',
  [ProfileDetailTabType.Reply]: '댓글',
  [ProfileDetailTabType.FancyShare]: '이멋공',
  [ProfileDetailTabType.Rolling]: '롤링',
};
